import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-checkmark.tsx
/**
* icon.16.checkmark
*
* Keywords: check, tick, confirm, approval, verify, correct, success, complete
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTIuNDE2IDQuMjc3YS41LjUgMCAxIDAtLjgzMi0uNTU0bC00LjY2MiA2Ljk5Mi0yLjU2OC0yLjU2OWEuNS41IDAgMCAwLS43MDguNzA4bDMgM2EuNS41IDAgMCAwIC43Ny0uMDc3eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=286-5632
*/
const Icon16Checkmark = memo(function Icon16Checkmark(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M12.416 4.277a.5.5 0 1 0-.832-.554l-4.662 6.992-2.568-2.569a.5.5 0 0 0-.708.708l3 3a.5.5 0 0 0 .77-.077z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon16Checkmark };

//# sourceMappingURL=icon-16-checkmark.js.map